import { useApi } from "hooks"
import { useSession } from "hooks";
import { useQuery } from "@tanstack/react-query";

const useGetBalance = () => {

  const { apiFetch } = useApi()
  const { isLoggedIn } = useSession()

  const url = `/me/balance`;

  const getBalance = () => {
    return apiFetch({ url })
      .then( res => res.data.amount)
  }

  const options = {
    staleTime: 30000, // 30 sec
    placeholderData: 0,
    enabled: isLoggedIn
  }

  return useQuery(['user', 'balance'], getBalance, options)
}

export default useGetBalance;